// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__Dn5sr","content":"GlobalSearch_content__1isFj"};